import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    bar: {
        height: '7px',
        backgroundColor: '#F4F4F4',
        borderRadius: '100px'
    }
});

const ProgressBar = ({progress}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <LinearProgress variant="determinate" value={progress} className={classes.bar}/>
        </div>
    )
};


export default ProgressBar;

